import { createFileRoute } from "@tanstack/react-router";
import { CustomEntityViewPage } from "~/pages/CustomEntityViewPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/custom/details/$id/view/$viewName")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id, datasetSlug, viewName } = Route.useParams();
  return <CustomEntityViewPage id={id} datasetSlug={datasetSlug} viewName={viewName} />;
}
